package com.bulut.mecitogullari.core.importer

import com.bulut.mecitogullari.core.export.safePdfName
import com.bulut.mecitogullari.core.util.YearMonth
import com.bulut.mecitogullari.core.util.formatDate
import com.bulut.mecitogullari.data.model.CashTransaction
import com.bulut.mecitogullari.data.model.TransactionType

/**
 * Builds the .xlsx rows for the ledger export — the exact same column layout
 * the importer reads back: Tarih | Tür | Kategori | Açıklama | Proje | Tutar.
 * "Ev Gideri" expenses are written as Tür "EV GİDER".
 */
object ExcelExport {

    fun fileNameForMonth(month: YearMonth): String =
        "islemler-${month.year}-${month.month.toString().padStart(2, '0')}.xlsx"

    fun fileNameForProject(projectName: String): String =
        "proje-${safePdfName(projectName)}.xlsx"

    fun rows(
        transactions: List<CashTransaction>,
        projectNames: Map<String, String>,
    ): List<List<ImportCell?>> {
        val header = listOf("Tarih", "Tür", "Kategori", "Açıklama", "Proje", "Tutar")
            .map { ImportCell.Text(it) }
        val body = transactions.sortedBy { it.dateEpochMillis }.map { tx ->
            listOf(
                ImportCell.Text(formatDate(tx.dateEpochMillis)),
                ImportCell.Text(
                    when {
                        tx.type == TransactionType.INCOME -> "GELİR"
                        tx.category == "Ev Gideri" -> "EV GİDER"
                        else -> "GİDER"
                    }
                ),
                ImportCell.Text(tx.category),
                ImportCell.Text(tx.description),
                ImportCell.Text(tx.projectId?.let { projectNames[it] } ?: ""),
                ImportCell.Number(tx.amount),
            )
        }
        return listOf(header) + body
    }
}
